var map = {
	"./gift_10.webp": 1684,
	"./gift_100.webp": 6612,
	"./gift_25.webp": 1936,
	"./gift_250.webp": 3384,
	"./gift_3.webp": 7094,
	"./gift_5.webp": 9144,
	"./gift_50.webp": 5024,
	"./gift_500.webp": 5512
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6164;